var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 3C8.4 4.32548 7.32548 5.4 6 5.4C4.67452 5.4 3.6 4.32548 3.6 3C3.6 1.67452 4.67452 0.6 6 0.6C7.32548 0.6 8.4 1.67452 8.4 3Z",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 20.2667V19.6667H3H0.6V9.53333C0.6 9.28159 0.697953 9.04275 0.86824 8.86868C1.03809 8.69506 1.26561 8.6 1.5 8.6H10.5C10.7344 8.6 10.9619 8.69506 11.1318 8.86868L11.5607 8.4491L11.1318 8.86868C11.302 9.04275 11.4 9.28159 11.4 9.53333V19.6667H9H8.4V20.2667V30.4H3.6V20.2667Z",
    stroke: "black",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 3C25.4 4.32548 24.3255 5.4 23 5.4C21.6745 5.4 20.6 4.32548 20.6 3C20.6 1.67452 21.6745 0.6 23 0.6C24.3255 0.6 25.4 1.67452 25.4 3Z",
    stroke: "black",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7363 9.27866L27.7363 9.27866L27.7371 9.28173L30.2095 18.1339H28H27.2356L27.4172 18.8764L28.7356 24.2669H26.5H25.9V24.8669V30.4H21.1V24.8669V24.2669H20.5H18.2644L19.5828 18.8764L19.7644 18.1339H19H16.7811L19.1437 9.27866C19.1439 9.27812 19.144 9.27759 19.1442 9.27705C19.2003 9.07333 19.321 8.89738 19.484 8.77575C19.6472 8.65399 19.8438 8.59312 20.0423 8.60062L20.0537 8.60105H20.065H26.815H26.8263L26.8377 8.60062C27.0362 8.59312 27.2328 8.65399 27.396 8.77575C27.5594 8.8977 27.6803 9.07426 27.7363 9.27866Z",
    stroke: "black",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllGender);
export default __webpack_public_path__ + "static/media/allGender.0850b027.svg";
export { ForwardRef as ReactComponent };